Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '';
__p += '<div class="row">\n  <div class="col-sm-2">\n    Users\n  </div>\n</div>';
return __p
}